export default {
    name: 'v5-icon-wrong',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M557.312 513.248l265.28-263.904c12.544-12.48 12.608-32.704.128-45.248-12.512-12.576-32.704-12.608-45.248-.128L512.128 467.904l-263.04-263.84c-12.448-12.48-32.704-12.544-45.248-.064-12.512 12.48-12.544 32.736-.064 45.28l262.976 263.776L201.6 776.8c-12.544 12.48-12.608 32.704-.128 45.248a31.937 31.937 0 0022.688 9.44c8.16 0 16.32-3.104 22.56-9.312l265.216-263.808 265.44 266.24c6.24 6.272 14.432 9.408 22.656 9.408a31.94 31.94 0 0022.592-9.344c12.512-12.48 12.544-32.704.064-45.248L557.312 513.248z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
